/**
 * Converts the UTC hour to the hour for the offset
 *
 * @param hour - The hour in UTC time
 * @param utcOffset - The offset in minutes from UTC
 * @returns - The hour in the new offsetted time
 */
export function convertUTCHourToOffsetHour(hour: number, utcOffset: number): number {
    const result = Math.round(hour - utcOffset / -60);

    /*
     * Clamp the result 0-24 repeating
     * E.g: 1 = 1, 23 = 23, 24 = 0, 25 = 1
     */
    return modulo(result, 24);
}

// This function is required because js doesn't handle the modulo operator correctly
function modulo(num: number, mod: number) {
    return ((num % mod) + mod) % mod;
}
